import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const QuestionIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 100 100">
    <g>
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={8}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M50,8C26.8,8,8,26.8,8,50c0,23.2,18.8,42,42,42s42-18.8,42-42C92,26.8,73.2,8,50,8z"
      />
      <path
        fill="currentColor"
        d="M50,22c-8.8,0-16,7.2-16,16h8c0-4.4,3.6-8,8-8s8,3.6,8,8c0,4-2.8,5.6-5.6,7.6C48.8,46,46,49.2,46,55v1h8v-1 c0-3.6,1.6-5.2,4.8-7.6C62,44.8,66,41.2,66,38C66,29.2,58.8,22,50,22z"
      />
      <circle fill="currentColor" cx="50" cy="68" r="4.5"/>
    </g>
  </SvgIcon>
);

export default QuestionIcon;
